import { render, staticRenderFns } from "./DemoBadge.vue?vue&type=template&id=d0d13c04&scoped=true"
import script from "./DemoBadge.vue?vue&type=script&lang=js"
export * from "./DemoBadge.vue?vue&type=script&lang=js"
import style0 from "./DemoBadge.vue?vue&type=style&index=0&id=d0d13c04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d13c04",
  null
  
)

export default component.exports